(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const preview = root.dataset.preview === 'true';
    const base = (window.Shopify?.routes?.root || root.dataset.root || '/').replace(/\/?$/, '/');
    const money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: root.dataset.currency || 'MXN', maximumFractionDigits: 0 });
    const cards = [...root.querySelectorAll('[data-product]')];
    const builder = root.querySelector('.nz-builder');
    const slots = root.querySelector('[data-slots]');
    const submit = root.querySelector('[data-submit]');
    const selection = [];
    let toastTimer, limit = 8, filter = 'all', busy = false;
    function notify(message) {
      clearTimeout(toastTimer);
      root.querySelector('[data-status]').textContent = message;
      toastTimer = setTimeout(() => { root.querySelector('[data-status]').textContent = ''; }, 6000);
    }
    function renderSelection() {
      slots.replaceChildren();
      for (let i = 0; i < 3; i++) {
        const li = document.createElement('li');
        const item = selection[i];
        if (item) {
          const img = document.createElement('img');
          img.src = item.image;
          img.alt = item.title + ' · ' + item.variant;
          li.append(img);
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.textContent = '×';
          remove.disabled = busy;
          remove.setAttribute('aria-label', 'Quitar ' + item.title + ' de tu selección');
          remove.addEventListener('click', () => {
            selection.splice(i, 1);
            renderSelection();
            notify(item.title + ' se eliminó de tu selección.');
            (slots.querySelector('button') || root.querySelector('[data-add]:not(:disabled)'))?.focus({ preventScroll: true });
          });
          li.append(remove);
        } else { li.textContent = String(i + 1).padStart(2, '0'); li.setAttribute('aria-label', 'Espacio ' + (i + 1) + ' sin elegir'); }
        slots.append(li);
      }
      const remaining = 3 - selection.length;
      root.querySelector('[data-progress]').textContent = remaining ? `Te ${remaining === 1 ? 'falta' : 'faltan'} ${remaining} ${remaining === 1 ? 'favorito' : 'favoritos'}` : 'Tu combinación está lista';
      const sum = selection.reduce((total, item) => total + item.price, 0);
      const total = remaining ? sum : sum - Math.min(...selection.map(item => item.price));
      root.querySelector('[data-total]').textContent = selection.length ? money.format(total / 100) : '—';
      root.querySelector('[data-total-label]').textContent = remaining ? 'Subtotal' : 'Total con 3×2';
      submit.disabled = remaining > 0 || busy;
      submit.textContent = busy ? 'AGREGANDO…' : remaining ? `ELIGE ${remaining} ${remaining === 1 ? 'LENTE MÁS' : 'LENTES'}` : 'AGREGAR LOS 3 A MI BOLSA ↗';
      updateBuilderVisibility();
    }
    function renderCards() {
      const matches = cards.filter(card => filter === 'all' || card.dataset.available === 'true');
      const visible = new Set(matches.slice(0, limit));
      cards.forEach(card => { card.hidden = !visible.has(card); });
      root.querySelector('[data-load-more]').hidden = matches.length <= limit;
    }
    cards.forEach(card => {
      const select = card.querySelector('[data-variant]');
      const originalImage = card.querySelector('.nz-product-image img');
      const defaultSrc = originalImage?.getAttribute('src');
      const defaultSrcset = originalImage?.getAttribute('srcset');
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        card.querySelector('[data-product-price]').textContent = money.format(Number(option.dataset.price) / 100);
        if (originalImage) {
          originalImage.src = option.dataset.image || defaultSrc;
          if (option.dataset.image) originalImage.removeAttribute('srcset');
          else if (defaultSrcset) originalImage.setAttribute('srcset', defaultSrcset);
        }
      });
      card.querySelector('[data-add]').addEventListener('click', () => {
        if (busy) return;
        if (selection.length >= 3) { notify('Ya elegiste tus tres. Quita uno de tu selección si quieres cambiarlo.'); return; }
        const option = select.selectedOptions[0];
        if (!option || option.disabled || card.dataset.available !== 'true') return;
        const title = card.querySelector('.nz-product-info a').textContent.trim();
        selection.push({ id: Number(option.value), title, variant: option.textContent.trim(), price: Number(option.dataset.price), image: option.dataset.image || originalImage?.currentSrc || originalImage?.src || '' });
        renderSelection();
        notify(selection.length === 3 ? 'Tu 3×2 está listo. Agrega tus tres favoritos a la bolsa.' : `${title} elegido. ${selection.length} de 3.`);
      });
    });
    root.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
      filter = button.dataset.filter;
      limit = 8;
      root.querySelectorAll('[data-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      renderCards();
    }));
    root.querySelector('[data-load-more]').addEventListener('click', () => {
      const previouslyVisible = new Set(cards.filter(card => !card.hidden));
      limit += 8;
      renderCards();
      cards.find(card => !card.hidden && !previouslyVisible.has(card))?.querySelector('a')?.focus({ preventScroll: true });
    });
    submit.addEventListener('click', async () => {
      if (selection.length !== 3 || busy) return;
      if (preview) { notify('Vista previa: tus 3 lentes están listos. En Shopify se agregarán a la bolsa real.'); return; }
      busy = true;
      renderSelection();
      const grouped = new Map();
      selection.forEach(item => grouped.set(item.id, (grouped.get(item.id) || 0) + 1));
      try {
        const response = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [...grouped].map(([id, quantity]) => ({ id, quantity })) }) });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'No pudimos agregar la selección. Revisa la disponibilidad e inténtalo de nuevo.');
        window.location.assign(base + 'cart');
      } catch (error) {
        notify(error.name === 'TypeError' || error.name === 'SyntaxError' ? 'No pudimos confirmar la operación. Revisa tu bolsa antes de volver a intentarlo.' : error.message || 'Hubo un problema de conexión. Revisa tu bolsa antes de volver a intentarlo.');
        busy = false;
        renderSelection();
      }
    });
    function updateBuilderVisibility() {
      builder.hidden = selection.length === 0 && root.querySelector('.nz-collection').getBoundingClientRect().top > window.innerHeight * .8;
    }
    window.addEventListener('scroll', updateBuilderVisibility, { passive: true });
    window.addEventListener('resize', updateBuilderVisibility, { passive: true });
    renderSelection();
    renderCards();
  }
  document.querySelectorAll('[data-nunzia-campaign]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-nunzia-campaign]').forEach(init));
})();
